import { QueryResult, useQuery, OperationVariables, ApolloError } from '@apollo/client';
import { Settings, StoreTypename, User } from 'types';
import GET_ME from '../../queries/me/get-me-query';

export const DEFAULT_CURRICULUM_KEY = 'defaultProductCurriculum';

export type UserStoreState = {
  me?: User;
  locale?: string;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  error: ApolloError | undefined;
};

export type UserStoreDispatch = {
  userRefetch: any;
  setDefaultCurriculumCode: (curriculumCode: string) => void;
  getDefaultCurriculumCode: () => string | null;
  clearDefaultCurriculumCode: () => void;
};

export type UserStore = [UserStoreState, UserStoreDispatch];

export const getDefaultUserStoreState = (): any => ({
  __typename: StoreTypename.USER,
});

const variables: OperationVariables = {
  settingsWhere: { appId: 16 },
  toursSettingsWhere: { tours: [Settings.WELCOME] },
};

const useUserStore = (): UserStore => {
  const {
    data,
    loading,
    error,
    refetch: userRefetch,
  }: QueryResult<{ me: User }> = useQuery(GET_ME, {
    variables: variables,
  });

  const getDefaultCurriculumCode = () => sessionStorage.getItem(DEFAULT_CURRICULUM_KEY);

  const setDefaultCurriculumCode = (curriculumCode: string) =>
    sessionStorage.setItem(DEFAULT_CURRICULUM_KEY, curriculumCode.toUpperCase());

  const clearDefaultCurriculumCode = () => sessionStorage.removeItem(DEFAULT_CURRICULUM_KEY);

  const isAuthenticated = data?.me && !error ? true : false;

  return [
    {
      me: data?.me,
      isAuthenticated,
      isAuthenticating: loading,
      error,
    },
    {
      getDefaultCurriculumCode,
      setDefaultCurriculumCode,
      clearDefaultCurriculumCode,
      userRefetch,
    },
  ];
};

export default useUserStore;
